<template>
  <BFileUpload
    v-bind="$attrs"
    :value="value"
    :upload-file="uploadFile"
    @input="$emit('input', $event)"
  />
</template>

<script>
import { FilesApi } from '@/api/resources'
import BFileUpload from '@/components/forms/BFileUpload.vue'


export default {
  name: 'FilesFormFileUpload',
  components: {
    BFileUpload,
  },
  inheritAttrs: false,
  props: {
    value: Object,
  },
  methods: {
    async uploadFile(file) {
      const api = new FilesApi()
      this.isLoading = true

      try {
        const { data } = await api.upload(file)
        return data
      } catch (e) {
        this.$notice.errors(e)
        return Promise.reject(e)
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
